import React, { useEffect, useState } from "react";
import { SalesforceSectionProps } from "../types/types";
import { Form } from "@components";

type RegionValues = {
  asiaPacific: string;
  canada: string;
  europe: string;
  unitedStates: string;
  global: string;
  mexico: string;
};

export const RegionSection: React.FC<SalesforceSectionProps> = ({
  sectionNumber,
  form,
  onFormValueChange,
}) => {
  const regionValues: RegionValues = {
    asiaPacific: "Asia Pacific (AP)",
    canada: "Canada (CA)",
    europe: "Europe (UK)",
    unitedStates: "United States (US)",
    global: "Global",
    mexico: "Mexico (MX)",
  };

  const [asiaPacificState, setAsiaPacificValuesState] = useState<boolean>(
    false
  );
  const [canadaState, setCanadaValuesState] = useState<boolean>(false);
  const [europeState, setEuropeValuesState] = useState<boolean>(false);
  const [unitedStatesState, setUnitedStatesValuesState] = useState<boolean>(
    false
  );
  const [globalState, setGlobalValuesState] = useState<boolean>(false);
  const [mexicoState, setMexicoValuesState] = useState<boolean>(false);

  useEffect(() => {
    console.log(form.values.region);
    const regions: string[] = form.values.region.split(",");
    regions.map((region) => {
      if (region === regionValues.asiaPacific) {
        setAsiaPacificValuesState(true);
      }

      if (region === regionValues.canada) {
        setCanadaValuesState(true);
      }

      if (region === regionValues.europe) {
        setEuropeValuesState(true);
      }

      if (region === regionValues.unitedStates) {
        setUnitedStatesValuesState(true);
      }

      if (region === regionValues.global) {
        setGlobalValuesState(true);
      }

      if (region === regionValues.mexico) {
        setMexicoValuesState(true);
      }
    });
  }, []);

  useEffect(() => {
    if (
      asiaPacificState ||
      canadaState ||
      europeState ||
      unitedStatesState ||
      globalState ||
      mexicoState
    ) {
      setRegions();
    }
  }, [
    asiaPacificState,
    canadaState,
    europeState,
    unitedStatesState,
    globalState,
    mexicoState,
  ]);

  const setRegions = () => {
    const regionsArray: string[] = [];

    if (asiaPacificState) {
      regionsArray.push(regionValues.asiaPacific);
    }

    if (canadaState) {
      regionsArray.push(regionValues.canada);
    }

    if (europeState) {
      regionsArray.push(regionValues.europe);
    }

    if (unitedStatesState) {
      regionsArray.push(regionValues.unitedStates);
    }

    if (globalState) {
      regionsArray.push(regionValues.global);
    }

    if (mexicoState) {
      regionsArray.push(regionValues.mexico);
    }

    const regions: string = regionsArray.join(",");
    console.log(regions);
    onFormValueChange("region", regions);
  };

  return (
    <>
      <Form.Title>{`${sectionNumber} - Region`}</Form.Title>
      <Form.Checkbox
        label={{
          text: regionValues.asiaPacific,
        }}
        name="asiaPacific"
        value={asiaPacificState}
        onChange={(name, value) => {
          setAsiaPacificValuesState(value);
        }}
        size={4}
      />

      <Form.Checkbox
        label={{
          text: regionValues.canada,
        }}
        name="canada"
        value={canadaState}
        onChange={(name, value) => {
          setCanadaValuesState(value);
        }}
        size={4}
      />

      <Form.Checkbox
        label={{
          text: regionValues.europe,
        }}
        name="europe"
        value={europeState}
        onChange={(name, value) => {
          setEuropeValuesState(value);
        }}
        size={4}
      />

      <Form.Checkbox
        label={{
          text: regionValues.unitedStates,
        }}
        name="unitedStates"
        value={unitedStatesState}
        onChange={(name, value) => {
          setUnitedStatesValuesState(value);
        }}
        size={4}
      />

      <Form.Checkbox
        label={{
          text: regionValues.global,
        }}
        name="global"
        value={globalState}
        onChange={(name, value) => {
          setGlobalValuesState(value);
        }}
        size={4}
      />

      <Form.Checkbox
        label={{
          text: regionValues.mexico,
        }}
        name="mexico"
        value={mexicoState}
        onChange={(name, value) => {
          setMexicoValuesState(value);
        }}
        size={4}
      />
    </>
  );
};
